import { render, staticRenderFns } from "./control-panel.vue?vue&type=template&id=223415b4&scoped=true"
import script from "./control-panel.vue?vue&type=script&lang=js"
export * from "./control-panel.vue?vue&type=script&lang=js"
import style0 from "./control-panel.vue?vue&type=style&index=0&id=223415b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223415b4",
  null
  
)

export default component.exports